//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function () {
	var App = angular.module('pphhApp');
	App.service("updateObsoleteEntitiesService", ["$http", "$q", function ($http, $q) {
	
		this.listMasterCodes = function() {
	
			var deferred = $q.defer();
	
			$http.get(_contextPath + "/updateCodeTable/listAccessCodes")
			.then(function(res) {
				deferred.resolve(res.data);
			});
			return deferred.promise;
		};
	
		this.getNumberObseleteRecords = function(tableAux){
			return $http.get(_contextPath + "/updateObsoleteEntities/searchNumber?tableAux="+tableAux);
		};
	
		this.getObseleteRecords = function(relatedTable, relatedField, fullFilter){
			var request = {
					method: "GET",
					url: _contextPath + "/updateObsoleteEntities/relatedTableRecords/",
					params: {
						relatedTable: relatedTable,
						relatedField: relatedField,
						fullFilter: fullFilter
					}
			};
			return $http(request);
		};
	
		this.updateSelectedObsoleteRecords = function(table, relatedTable, selectedCandidates){
			var request = {
					method: "POST",
					url: _contextPath + "/updateObsoleteEntities/updateSelectedObsoleteRecords/" + table + "/" + relatedTable + "/",
					data: selectedCandidates
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		};
	
	}]);
})();
